<aza-rws-profile-header *ngIf="showLogin" titleTranslationKey="LOGIN" (closed)="onClosed()"></aza-rws-profile-header>
<aza-rws-profile-header *ngIf="showResetPassword" titleTranslationKey="FORGOT_MY_PASSWORD" (closed)="onClosed()">
</aza-rws-profile-header>
<aza-rws-profile-header *ngIf="showVerificationCode" titleTranslationKey="CHECK_YOUR_EMAIL" (closed)="onClosed()">
</aza-rws-profile-header>
<div class="profile-profile-login">
  <div class="section-form-single-column aza-section aza-theme aza-form">
    <div class="aza-section-content aza-section-colors">
      <div class="aza-form-field-area">
        <div class="aza-input-field">
          <div class="aza-field-content aza-field-type-text">
            <label class="aza-text" translate>EMAIL</label>
            <input [(ngModel)]="email" [disabled]="showVerificationCode" />
          </div>
        </div>
        <div *ngIf="showLogin" class="aza-input-field">
          <div class="aza-field-content aza-field-type-text">
            <label class="aza-text" translate>PASSWORD</label>
            <input [(ngModel)]="password" type="password" />
          </div>
        </div>
        <div *ngIf="showVerificationCode" class="aza-input-field">
          <div class="aza-field-content aza-field-type-text">
            <label class="aza-text" translate>VERIFICATION_CODE</label>
            <input [(ngModel)]="verificationCode" />
          </div>
        </div>
      </div>
    </div>
    <section *ngIf="loginFailed" class="aza-section aza-theme profile-login-failed">
      <a href="/">
        <span translate>LOGIN_FAILED</span>
      </a>
    </section>
    <div class="section-form-single-column aza-section aza-theme aza-form">
      <div class="aza-section-content aza-section-colors">
        <div class="aza-form-field-area">
          <div *ngIf="showLogin" class="aza-input-field">
            <section
              class="section-form-button aza-section aza-theme profile-change-password-confirm-container profile-control-actions-container">
            </section>
            <!-- <div class="aza-field-content aza-field-type-text">
              <label class="aza-text">
                <a href="#" (click)="onForgotPassword($event)" translate>FORGOT_MY_PASSWORD</a>
              </label>
            </div> -->
          </div>
          <!-- <div *ngIf="showResetPassword && email" class="aza-input-field">
            <div class="aza-field-content aza-field-type-text">
              <label class="aza-text">
                <a href="#" (click)="onVerifyEmail($event)" translate>VERIFY_MY_EMAIL</a>
              </label>
            </div>
          </div> -->
          <section *ngIf="showResetPassword && email" class="section-form-button aza-section aza-theme">
            <div class="aza-section-content aza-section-colors">
              <button (click)="onVerifyEmail($event)"
                class="aza-button aza-section-inverted-colors profile-change-password-confirm-button"
                translate>VERIFY_MY_EMAIL</button>
            </div>
          </section>
          <!-- <div *ngIf="showVerificationCode && verificationCode" class="aza-input-field">
            <div class="aza-field-content aza-field-type-text">
              <label class="aza-text">
                <a href="#" (click)="onResetAccount($event)" translate>RESET_MY_ACCOUNT</a>
              </label>
            </div>
          </div> -->
          <section *ngIf="showVerificationCode && verificationCode" class="section-form-button aza-section aza-theme">
            <div class="aza-section-content aza-section-colors">
              <button (click)="onResetAccount($event)"
                class="aza-button aza-section-inverted-colors profile-change-password-confirm-button"
                translate>RESET_MY_ACCOUNT</button>
            </div>
          </section>
        </div>
      </div>
    </div>
    <section *ngIf="showLogin"
      class="section-form-button aza-section aza-theme profile-login-confirm-container profile-control-actions-container">
      <div class="aza-section-content aza-section-colors">
        <button (click)="onLogin()" [disabled]="!email || !password"
          class="aza-button aza-section-inverted-colors profile-login-confirm-button" translate>LOGIN</button>
      </div>
    </section>
    <section *ngIf="showLogin" class="section-form-button aza-section aza-theme">
      <div class="aza-section-content aza-section-colors">
        <button (click)="onForgotPassword($event)"
          class="aza-button aza-section-inverted-colors profile-change-password-confirm-button"
          translate>FORGOT_MY_PASSWORD</button>
      </div>
    </section>
    <!-- <section *ngIf="passwordChanged" class="aza-section aza-theme profile-password-has-been-changed-container">
            <span translate>PASSWORD_HAS_BEEN_CHANGED</span>
        </section> -->
  </div>
</div>
